import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function CursoModulos({ infoEspecificaCurso,cursoID }) {
  // Función para actualizar el estado de cada lección basada en su propiedad "terminado"
  const updateLessonStates = (secciones) => {
    let inProgressSet = false; // Bandera para asignar "en curso" sólo a la primera lección pendiente
    secciones.forEach((seccion) => {
      seccion.lecciones_info.forEach((leccion) => {
        if (leccion.terminado) {
          leccion.estado = "terminado";
        } else if (!inProgressSet) {
          leccion.estado = "en curso";
          inProgressSet = true;
        } else {
          leccion.estado = "sin empezar";
        }
      });
    });
  };

  // Llamamos a la función para actualizar los estados antes de renderizar
  updateLessonStates(infoEspecificaCurso);

  // Función para cambiar de lección similar a la que tienes en TemarioCursoComprado
  const navigate = useNavigate();

  const cambiarLeccionId = (nuevoId) => {
    navigate(`?f=cc&curso_id=${cursoID}&leccion_id=${nuevoId}`);
    window.location.reload();
  };

  // Función que retorna los íconos correspondientes al estado de la lección
  const selectIcon = (estado) => {
    switch (estado) {
      case "terminado":
        return (
          <>
            <i className="fi fi-rs-check-circle" style={{ color: "#A5FF32" }}></i>
          </>
        );
      case "en curso":
        return (
          <>
            <i className="fi fi-sr-loading" style={{ color: "#1DE8F5" }}></i>
          </>
        );
      default:
        return (
          <>
            <i className="fi fi-rr-circle" style={{ color: "#707585" }}></i>
          </>
        );
    }
  };

  return (
    <div data-figma-id="1623:15232" className="curso-ventana-emergente-modulos">
      {infoEspecificaCurso.map((seccion, modIndex) => (
        <div key={seccion.id_seccion} className="curso-modulo-1">
          <p className="curso-modulo-1-texto">{seccion.nombre_seccion}</p>
          {seccion.lecciones_info.map((leccion) => (
            <div
              key={leccion.leccion_id}
              className={
                leccion.estado === "terminado" || leccion.estado === "en curso"
                  ? "curso-modulo-1-leccion"
                  : "curso-modulo-2-leccion"
              }
              onClick={() =>
                (leccion.estado === "terminado" || leccion.estado === "en curso") &&
                cambiarLeccionId(leccion.leccion_id)
              }
            >
              {selectIcon(leccion.estado)}
              <p
                className={
                  leccion.estado === "terminado" || leccion.estado === "en curso"
                    ? "curso-modulo-1-leccion-texto-1"
                    : "curso-modulo-2-leccion-texto"
                }
              >
                {leccion.leccion_nombre}
              </p>
            </div>
          ))}
          {modIndex !== infoEspecificaCurso.length - 1 && (
            <div className="linea-miscursos-h-detalle-curso"></div>
          )}
        </div>
      ))}
    </div>
  );
}
